import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const lang = localStorage.getItem('lang') || 'en';

  if (authService.isLoggedIn()) {
    return true;
  }

  return router.createUrlTree([`/${lang}/home`]);
};
